import Vue from "vue";
import Vuex from "vuex";
import router from "./router";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./filters";
import { components } from "./settings";
import vueSmoothScroll from "vue2-smooth-scroll";
import firebase from "firebase";
import VueWebP from "v-webp";

Vue.config.productionTip = false;
var firebaseConfig = {
  apiKey: "AIzaSyCXino9b4djQTxjY-jBhRW4RTRQsC_rQaI",
  authDomain: "capitalica-85186.firebaseapp.com",
  databaseURL: "https://capitalica-85186.firebaseio.com",
  projectId: "capitalica-85186",
  storageBucket: "capitalica-85186.appspot.com",
  messagingSenderId: "48787458073",
  appId: "1:48787458073:web:58208bac88b1b2bdcd0288",
  measurementId: "G-FMZN1ZTHJ6",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

//Activación de componentes externos
Vue.use(Vuex);
Vue.use(vueSmoothScroll);
Vue.use(VueWebP);
import store from "./stores";

// Cargador de componentes
// modals.forEach(function (e) {
//   Vue.component(
//     e.name,
//     require(`./components/modals/${e.component}`).default
//   );
// });
components.forEach(function(e) {
  Vue.component(
    e.name,
    require(`./components/components/${e.component}`).default
  );
});

Vue.config.productionTip = false;
Vue.filter("phone", function(phone) {
  return phone
    .replace(/[^0-9]/g, "")
    .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
